/**
 * The provider selected when `/auth/config` returns `provider: "local"`.
 *
 * It resolves immediately to the single user the backend serves, so the sidebar footer renders a
 * real record from the first commit rather than a hardcoded name, and attribution is never
 * retrofitted.
 */

import type { AuthContextValue, AuthUser } from './types';

export function localAuth(user: AuthUser): AuthContextValue {
  return {
    status: 'authenticated',
    user,
    getAccessToken: async () => null,
    login: () => undefined,
    logout: () => undefined,
  };
}
